<script>
export default {
    name: 'IlluNumber1',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-number1"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M19.5 38.5c.428 2.977.881 4.521 1.36 4.633 1.714.402 4.392-.905 5.14-.633 1.061.386 1.728.553 2 .5l-4.806 12.09c-.222.609-.928.911-1.577.675a1.292 1.292 0 01-.712-.625l-1.226-2.428a1.308 1.308 0 00-1.661-.605l-2.5 1.072a1.308 1.308 0 01-1.661-.604 1.14 1.14 0 01-.06-.906L19.5 38.5zm25 .5l5.955 12.65a1.14 1.14 0 01-.06.905 1.308 1.308 0 01-1.66.605l-2.5-1.072a1.308 1.308 0 00-1.662.604l-1.225 2.428a1.292 1.292 0 01-.713.626c-.649.236-1.355-.067-1.577-.676L36 43c.272.053.939-.114 2-.5.748-.272 3.678 1.015 5.393.614C43.87 43 44.24 41.63 44.5 39zM34 22v12h-2.98v-9.345l-2.393.511L28 23.021 31.941 22H34z"
                :fill="primaryColor" class="primary-color"
            />
            <path
                d="M33.023 9.81a1.495 1.495 0 00-2.112.065l-2.715 2.864a2.5 2.5 0 01-2.393.712l-3.849-.914a1.495 1.495 0 00-1.754 1.181l-.796 4.014a2.5 2.5 0 01-1.59 1.861l-3.764 1.382a1.493 1.493 0 00-.832.785c-.158.35-.182.76-.036 1.147l1.592 4.208a2.5 2.5 0 010 1.77l-1.598 4.226c-.142.384-.113.794.048 1.143.161.348.455.635.844.778l3.746 1.375a2.5 2.5 0 011.59 1.86l.81 4.079a1.495 1.495 0 001.804 1.104l3.785-.9a2.5 2.5 0 012.393.711l2.78 2.93c.3.278.684.412 1.064.402.384-.01.763-.167 1.048-.468l2.716-2.864a2.5 2.5 0 012.393-.712l3.849.914a1.495 1.495 0 001.754-1.181l.796-4.014a2.5 2.5 0 011.59-1.861l3.764-1.382c.383-.145.674-.435.832-.785.158-.35.182-.76.036-1.147l-1.592-4.208a2.5 2.5 0 010-1.77l1.598-4.226a1.493 1.493 0 00-.048-1.143 1.495 1.495 0 00-.844-.778l-3.746-1.375a2.5 2.5 0 01-1.59-1.86l-.81-4.079a1.495 1.495 0 00-.67-.922 1.495 1.495 0 00-1.134-.182l-3.785.9a2.5 2.5 0 01-2.393-.711l-2.78-2.93z"
                :stroke="secondaryColor" class="secondary-color"
            />
            <circle :stroke="secondaryColor" class="secondary-color" cx="32" cy="28" r="10.5" />
        </g>
    </svg>
</template>
